import React from 'react';
import { letterColor, fmtPct, fmtGpa } from './gradeUtils';

export const GpaHeadline = ({ summary }) => (
  <div className="grid grid-cols-3 gap-2" data-testid="grade-headline">
    <div className="border-2 border-zinc-800 p-3">
      <div className="text-[9px] font-black uppercase tracking-[0.25em] text-zinc-500">Cumulative GPA</div>
      <div className="text-3xl font-black text-white leading-none mt-1" data-testid="grade-gpa">{fmtGpa(summary.gpa)}</div>
    </div>
    <div className="border-2 p-3" style={{ borderColor: letterColor(summary.letter) }}>
      <div className="text-[9px] font-black uppercase tracking-[0.25em] text-zinc-500">Letter Grade</div>
      <div className="text-3xl font-black leading-none mt-1" style={{ color: letterColor(summary.letter) }} data-testid="grade-letter">{summary.letter || '—'}</div>
    </div>
    <div className="border-2 border-zinc-800 p-3">
      <div className="text-[9px] font-black uppercase tracking-[0.25em] text-zinc-500">Overall</div>
      <div className="text-3xl font-black text-white leading-none mt-1" data-testid="grade-overall-percent">{fmtPct(summary.overall_percent)}</div>
    </div>
  </div>
);

export const SubjectGrades = ({ summary, active, onSelect }) => (
  <div className="space-y-1.5" data-testid="subject-grades">
    {summary.subjects.map((s) => (
      <button
        key={s.key}
        type="button"
        onClick={() => onSelect && onSelect(active === s.key ? 'all' : s.key)}
        className={`w-full flex items-center justify-between gap-3 border-2 px-3 py-2 text-left transition-colors ${active === s.key ? 'border-emerald-500 bg-emerald-500/10' : 'border-zinc-800 hover:border-zinc-600'}`}
        data-testid={`subject-grade-${s.key}`}
      >
        <span className="text-xs font-black uppercase tracking-widest text-zinc-200">{s.label}</span>
        <span className="flex items-center gap-3 shrink-0">
          <span className="text-[11px] text-zinc-400">{fmtPct(s.percent)}</span>
          <span className="text-[11px] text-zinc-500 w-8 text-right">{fmtGpa(s.gpa_points)}</span>
          <span className="text-sm font-black w-8 text-right" style={{ color: letterColor(s.letter) }}>{s.letter || '—'}</span>
        </span>
      </button>
    ))}
  </div>
);

export const CategoryList = ({ categories, averages }) => (
  <div className="space-y-1" data-testid="category-breakdown">
    {categories.map((c) => {
      const v = averages[c.key];
      return (
        <div key={c.key} className="flex items-center justify-between gap-3 border-b border-zinc-800 py-1.5" data-testid={`radar-category-${c.key}`}>
          <span className="text-[11px] text-zinc-300 font-medium">{c.label} <span className="text-zinc-600">· {c.weight}%</span></span>
          <span className="flex items-center gap-2 shrink-0">
            <span className="w-20 h-1.5 bg-zinc-800 rounded-full overflow-hidden"><span className="block h-full bg-emerald-500 transition-all duration-700" style={{ width: `${v ?? 0}%` }} /></span>
            <span className="text-xs font-black text-white w-12 text-right">{v === null || v === undefined ? '—' : fmtPct(v)}</span>
          </span>
        </div>
      );
    })}
  </div>
);
